import styles from './App.module.scss';
import { Header } from './components/Header/Header';
import { About } from './components/About/About';
import { TechStack } from './components/TechStack/TechStack';
import { Experience } from './components/Experience/Experience';
import { Projects } from './components/Projects/Projects';
import { Contact } from './components/Contact/Contact';
import { Footer } from './components/Footer/Footer';

function App() {
  return (
    <div className={styles.app}>
      <Header />
      <main className={`${styles.main} pagePad`}>        <section className={`container ${styles.hero}`} id="home" aria-label="Hero">
          <div className={styles.heroInner}>
            <img src="/me.jpg" alt="Headshot" style={{ display: 'none' }} />
            <div>
              <h1 className={styles.title}>Rapolas Skripkauskas</h1>
              <p className={styles.subtitle}>
                Full-stack Engineer • Technical Project Manager
              </p>
              <div className={styles.ctas}>
                <a className={`${styles.cta} ${styles.ctaPrimary}`} href="#contact">Get in touch</a>
                <a className={styles.cta} href="#projects">View projects</a>
                <a className={styles.cta} href="#experience">Experience</a>
              </div>
            </div>
          </div>
        </section>

        <About />
        <TechStack />
        <Experience />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;